import React from 'react'
import PropTypes from 'prop-types'
import omit from 'lodash/omit'

class VideoLoader extends React.Component {
  static propTypes = {
    videoRef: PropTypes.func
  }

  static defaultProps = {
    videoRef: () => {}
  }

  constructor (props) {
    super(props)
    this.state = {
      isLoading: false
    }

    this.onWaiting = this.onWaiting.bind(this)
    this.onCanPlay = this.onCanPlay.bind(this)
  }

  componentDidMount () {
    this.$video.addEventListener('waiting', this.onWaiting)
    this.$video.addEventListener('canplay', this.onCanPlay)
  }

  componentWillUnmount () {
    this.$video.removeEventListener('waiting', this.onWaiting)
    this.$video.removeEventListener('canplay', this.onCanPlay)
  }

  onWaiting () {
    this.setState({isLoading: true})
  }

  onCanPlay () {
    this.setState({isLoading: false})
  }

  videoRef ($video) {
    this.$video = $video
    this.props.videoRef($video)
  }

  render () {
    const videoProps = omit(this.props, ['videoRef'])
    const { isLoading } = this.state

    return (
      <div className='video-loader'>
        {isLoading && <div className='video-loader__spinner' />}
        <video {...videoProps} ref={this.videoRef.bind(this)}>
          {this.props.children}
        </video>
      </div>
    )
  }
}

export default VideoLoader



// WEBPACK FOOTER //
// ./client/components/videoLoader.js